import React, { useCallback, useEffect, useState } from 'react';
import TranslationsContext, { ITranslationsContext } from './TranslationsContext';
import { SupportedLangs, supportedLangsList } from 'i18n';
import { useTranslation } from 'react-i18next';
import translationsProvider from './translationsProvider';

interface ITranslationsWrapperProps {
    children: React.ReactNode;
}

const isSupportedLang = (langCode: string): boolean => {
	const supportedLangCodes = supportedLangsList.map(i => i.code.toLowerCase());
	return langCode && supportedLangCodes.includes(langCode.toLowerCase());
};

const matchSupportedLangCode = (langCode: string): string => {
	if (isSupportedLang(langCode)) {
		return langCode;
	}
	if (langCode && langCode.length > 2) {
		const langCodeWithoutRegion = langCode.substring(0, 2);
		if (isSupportedLang(langCodeWithoutRegion)) {
			return langCodeWithoutRegion;
		}
	}
	return SupportedLangs.en.code;
};

const TranslationsWrapper = ({ children }: ITranslationsWrapperProps) => {

	const { t: translate, i18n } = useTranslation();
	const [selectedLangCode, setSelectedLangCode] = useState(() => matchSupportedLangCode(translationsProvider.language));

	useEffect(() => {
		if (i18n.language !== selectedLangCode) {
			i18n.changeLanguage(selectedLangCode);
			window.location.reload();
		}
	}, [selectedLangCode]);

	const t = useCallback((key: string | string[], options?: any): string => translate(key, options) as unknown as string, [translate]);

	const translationsContext: ITranslationsContext = {
		selectedLangCode,
		setSelectedLangCode,
		t
	};

	return (
		<TranslationsContext.Provider value={translationsContext}>
			{children}
		</TranslationsContext.Provider>
	);
};

export default TranslationsWrapper;
